// removed by extract-text-webpack-plugin
module.exports = {"container":"styles_container__93Y2W","image":"styles_image__1WUD7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ImageGallery/styles.module.css
// module id = 97
// module chunks = 0